import { gql } from "@apollo/client";

export const getRemoteAssetLensUsages = gql`
    query getRemoteAssetLensUsages($id: ID!, $cursor: String, $limit: Int = 10) {
        remoteAsset(input: { id: $id }) {
            id
            usedByLensesConnection(cursor: $cursor, limit: $limit) {
                nodes {
                    lensId
                    lensName
                }
                cursor
            }
        }
    }
`;
